import { useState, useEffect, useCallback } from 'react';
import { supabase } from '../lib/supabase';
import { useAuth } from '../context/AuthContext';

export function usePreferences() {
  const { user } = useAuth();
  const [preferences, setPreferences] = useState(null);
  const [loading, setLoading] = useState(true);

  const fetchPreferences = useCallback(async () => {
    if (!user) {
      setPreferences(null);
      setLoading(false);
      return;
    }
    setLoading(true);
    const { data } = await supabase
      .from('buyer_preferences')
      .select('*')
      .eq('user_id', user.id)
      .maybeSingle();
    setPreferences(data || null);
    setLoading(false);
  }, [user]);

  useEffect(() => {
    fetchPreferences();
  }, [fetchPreferences]);

  async function savePreferences(updates) {
    if (!user) return { error: new Error('Not signed in') };
    const { data, error } = await supabase
      .from('buyer_preferences')
      .upsert({ user_id: user.id, ...updates }, { onConflict: 'user_id' })
      .select()
      .single();

    if (!error) setPreferences(data);
    return { data, error };
  }

  return { preferences, loading, savePreferences, refetch: fetchPreferences };
}
